(function () {
        if (window.__euLgReady) return;
        window.__euLgReady = true;

        // Notificarea (SVG A4, ~600 KB) se descarca abia la prima deschidere.
        function fill(dialog) {
          var img = dialog.querySelector('img[data-src]');
          if (img) { img.src = img.getAttribute('data-src'); img.removeAttribute('data-src'); }
        }

        document.addEventListener('click', function (e) {
          var opener = e.target.closest('[data-eu-lg-open]');
          if (opener) {
            var dlg = document.getElementById(opener.getAttribute('data-eu-lg-open'));
            if (dlg) {
              fill(dlg);
              if (typeof dlg.showModal === 'function') { dlg.showModal(); } else { dlg.setAttribute('open', ''); }
            }
            return;
          }
          var closer = e.target.closest('[data-eu-lg-close]');
          if (closer) {
            var d = closer.closest('dialog');
            if (d) { if (typeof d.close === 'function') { d.close(); } else { d.removeAttribute('open'); } }
            return;
          }
          // click pe fundal inchide dialogul
          if (e.target.tagName === 'DIALOG' && e.target.classList.contains('eu-lg__dialog')) {
            e.target.close();
          }
        }, true); // capture: Eurus quick view calls stopPropagation() on clicks inside it

        // Escape closes only the notice, not the cart drawer / quick view behind it
        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' && e.target.closest && e.target.closest('.eu-lg__dialog[open]')) { e.stopPropagation(); }
        }, true);
      })();
